@import '@hevoio/hevo-ui-toolkit/styles/variables';

$rowPadding: $spacer * 0.75 $spacer * 1.25;
$cellLeftMargin: $spacer * 2;
$cellWidth: 120px;

.pipelinesListContainer {
  display: flex;
  justify-content: center;
  margin-top: $spacer * 2;
  overflow: hidden;

  .pipelinesList {
    width: 1200px;
    border-radius: $border-radius-md;
    border: $border-width solid $divider-color;
    flex-direction: column;
    display: flex;
    flex: 1;
  }
  .listPrimaryHeader {
    padding: $spacer * 0.5 $spacer * 1.25;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: solid $border-width $divider-color;
  }
}

.listItemContainer {
  overflow-y: auto;
}

.listItem {
  padding: $rowPadding;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid $border-width $divider-color;
}

//table styles
.pipelineDetailsCell {
  display: flex;
  width: 388px;
  align-items: center;
}

.genericCell {
  display: flex;
  width: 130px;
  align-items: center;
  margin-left: $spacer * 2;
}

.frequencyMenuTriggerWrapper {
  display: flex;
  border: $border-width solid $divider-color;
  border-radius: $border-radius-md;

  & button {
    padding: 7px 12px;
    width: 96px;
    display: flex;
    justify-content: space-between;
    border-radius: 0 $border-radius-md $border-radius-md 0;
  }
}

.bulkUpdateContainer {
  display: flex;
  padding: $rowPadding;
  border-bottom: solid $border-width $divider-color;
  justify-content: center;
  align-items: center;
}
